import { render } from "./RenderSubMenu.vue?vue&type=template&id=8ec7f08a&scoped=true"
import script from "./RenderSubMenu.vue?vue&type=script&lang=js"
export * from "./RenderSubMenu.vue?vue&type=script&lang=js"

import "./RenderSubMenu.vue?vue&type=style&index=0&id=8ec7f08a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ec7f08a"]])

export default __exports__